var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-dialog",
    {
      attrs: {
        value: _vm.open,
        persistent: "",
        "content-class": "confirm-dialog"
      }
    },
    [
      _c(
        "q-card",
        {
          staticClass: "q-pa-lg full-width confirm-dialog__card",
          staticStyle: { "min-width": "350px", "max-width": "625px" }
        },
        [
          _c(
            "q-form",
            { staticClass: "q-mb-none" },
            [
              _c("q-card-section", [
                _c("div", { staticClass: "confirm-dialog__title" }, [
                  _vm._v("\n          " + _vm._s(_vm.title) + "\n        ")
                ])
              ]),
              _vm._v(" "),
              _c("q-card-section", [_vm._t("default")], 2),
              _vm._v(" "),
              _c(
                "q-card-actions",
                {
                  staticClass: "text-primary q-px-md q-pb-md",
                  attrs: { align: "right" }
                },
                [
                  _vm.cancelButton
                    ? _c("q-btn", {
                        attrs: { flat: "", label: _vm.cancelButton },
                        on: {
                          click: function($event) {
                            return _vm.answer("cancel")
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("q-btn", {
                    attrs: {
                      color: "primary",
                      unelevated: "",
                      label: _vm.confirmButton
                    },
                    on: {
                      click: function($event) {
                        return _vm.answer("confirm")
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }